import typeCheck from 'common/util/typeCheck';
import analytics from 'client/analytics';
import { ANALYTICS_EVENT_ROOMMATE_SIGNUP } from 'client/analytics/eventList';
import { USER_ROLE_ANONYMOUS } from 'common/userRoles';
import { onLogicSuccess } from 'client/actions/Auth/login';

import {
  SR_API_ACTION_ROOMMATE_SIGNUP,
} from 'api/actionTypes';

export default async function roommateSignup({ state, apiClient }, params) {
  typeCheck('params::Object', params);

  const wasAlreadyLoggedIn = !state.get(['currentUser', 'roles']).includes(USER_ROLE_ANONYMOUS);

  const {
    name,
    phone,
    email,
    password,
    shouldUpdatePassword,
    originalRenterPhone,
    skipLogin,
  } = params;

  typeCheck('name::NonEmptyString', name);
  typeCheck('email::Maybe Email', email);
  typeCheck('phone::Phone', phone);
  typeCheck('password::NonEmptyString', password);
  typeCheck('originalRenterPhone::Phone', originalRenterPhone);

  const analyticsSessionId = state.get(['analytics', 'analyticsSessionId']);
  const experimentActiveVariants = state.get(['analytics', 'experiments', 'activeVariants']);
  await apiClient.postWithState({
    action: SR_API_ACTION_ROOMMATE_SIGNUP,
    state: state,
    payload: {
      name,
      phone,
      email,
      password,
      shouldUpdatePassword,
      originalRenterPhone,
      analyticsSessionId,
      skipLogin,
      experimentActiveVariants,
    },
    async onSuccess({ user }) {
      if (!skipLogin) {
        await onLogicSuccess({
          state,
          apiClient,
          user,
        });
      }

      analytics.track(ANALYTICS_EVENT_ROOMMATE_SIGNUP, {
        phone,
        originalRenterPhone,
        wasAlreadyLoggedIn,
      });
    },
  });
}
